import * as React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import withStyles from '@material-ui/core/styles/withStyles'
import Facebook2Icon from 'components/icons/Facebook2'
import Button from 'components/Button'

export const styles = (theme) => ({
  root: {
    backgroundColor: '#3C5A96',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#3C5A96',
    },
    '&[disabled]': {
      backgroundColor: theme.palette.action.disabledBackground,
      color: theme.palette.action.disabled,
    },
  },
})

const FacebookButton = React.forwardRef(function FacebookButton(props, ref) {
  const { children, classes, className, ...other } = props

  return (
    <Button
      className={clsx(classes.root, className)}
      startIcon={<Facebook2Icon />}
      ref={ref}
      {...other}
    >
      {children}
    </Button>
  )
})

FacebookButton.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
}

export default withStyles(styles)(FacebookButton)
